import { formatDate, getDurationObject } from '@thoughtspot/date-format-util';
import { translate as t } from '@thoughtspot/i18n';
import { formatDataValue } from '@thoughtspot/number-format-util';
import _ from 'lodash';
export const tablesLoaded = (numReady, numStale) => {
    return numReady + numStale;
};
export const getFormattedCompressionRatio = (uncompressedVal, compressedVal) => {
    if (_.isNaN(uncompressedVal) ||
        _.isNaN(compressedVal) ||
        uncompressedVal === 0 ||
        uncompressedVal <= compressedVal) {
        return '1 : 1';
    }
    const compressionRatio = uncompressedVal / compressedVal;
    return `1 : ${formatDataValue(compressionRatio, { nDecimal: 2 })}`;
};
export const dbTableDateFormatter = (value) => {
    return formatDate(value / 1000, 'DEFAULT_TIME_FORMAT');
};
export const TableInfoColumns = [
    {
        headerName: t('adminUI.captions.DATABASE_NAME'),
        id: 'database',
        minWidth: 190,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.USER_SCHEMA_NAME'),
        id: 'userSchema',
        minWidth: 160,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_TABLE_NAME'),
        id: 'name',
        minWidth: 270,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_TABLE_STATUS'),
        id: 'status',
        maxWidth: 127,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_CREATED_ON'),
        id: 'lastUploadedAt',
        minWidth: 210,
        valueGetter: dbTableDateFormatter,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_NUM_ROWS'),
        id: 'totalRowCount',
        maxWidth: 130,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_REPLICATED'),
        id: 'replicated',
        maxWidth: 130,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_USED_CSV_CAPACITY'),
        id: 'usedCSVCapacity',
        maxWidth: 130,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_ROW_SKEW'),
        id: 'rowCountSkew',
        maxWidth: 125,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.SEARCH_TABLE_STATUS'),
        id: 'searchStatus',
        maxWidth: 125,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.SEARCH_LAST_BUILD_DURATION'),
        id: 'lastIndexBuildDuration',
        maxWidth: 125,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATABASE_TOTAL_SHARDS'),
        id: 'totalShards',
        maxWidth: 140,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.DATA_COMPRESSION'),
        id: 'compression',
        maxWidth: 165,
        sortable: true,
    },
];
export const NodeInfoColumns = [
    {
        headerName: t('adminUI.captions.NODE_IP'),
        id: 'nodeId',
        minWidth: 190,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.RAMDISK_USAGE'),
        id: 'ramdiskUsage',
        minWidth: 162,
        sortable: true,
    },
    {
        headerName: t('adminUI.captions.CAPACITY'),
        id: 'capacity',
        minWidth: 270,
        sortable: true,
    },
];
export const getValueOrEmptyString = (num) => {
    if (num < 0) {
        return '';
    }
    return getDurationObject(num).toFormat("h'h'm'm's's'");
};
export const getNumberOrEmptyString = (num) => {
    if (num < 0) {
        return '';
    }
    return Math.round(num * 100) / 100;
};
export const getStringForReplicated = (replicated) => {
    if (replicated === true) {
        return 'Y';
    }
    if (replicated === false) {
        return 'N';
    }
    return '';
};
export const prepareTableRowDataEvents = (data) => {
    if (data.length === 0) {
        return [];
    }
    return data.map((item) => ({
        database: item.database,
        userSchema: item.schema,
        name: item.name,
        status: item.databaseStatus,
        lastUploadedAt: item.lastUploadedAt,
        totalRowCount: item.numOfRows,
        replicated: getStringForReplicated(item.replicated),
        usedCSVCapacity: getNumberOrEmptyString(item.csvSizeWithReplicationMB),
        rowCountSkew: item.rowSkew,
        searchStatus: item.state,
        lastIndexBuildDuration: getValueOrEmptyString(item.lastBuildTime),
        totalShards: item.numShards,
        compression: getFormattedCompressionRatio(item.uncompressedByteSize, item.approxByteSize),
    }));
};
export const prepareNodeRowDataEvents = (data) => {
    if (data.length === 0) {
        return [];
    }
    return data.map((item) => ({
        nodeId: item.ip,
        ramdiskUsage: item.ramdisk,
        capacity: getNumberOrEmptyString(item.capacity),
    }));
};
export const nodeList = (filterList) => {
    const allDestionTypeObject = {
        id: 'all',
        name: 'all',
    };
    const options = [
        {
            id: allDestionTypeObject.id,
            label: allDestionTypeObject.name,
            data: allDestionTypeObject,
        },
    ];
    return [
        {
            options: options.concat(filterList.map(item => ({
                id: item.ip,
                label: item.ip,
                data: item,
            }))),
        },
    ];
};
//# sourceMappingURL=table-status-utils.js.map